import trim from 'hs-lodash/trim';
export const kebabToSpacedCamel = kebab => {
  return trim(kebab.split('-').map(word => word.length > 0 ? word[0].toUpperCase() + word.slice(1) : null).join(' '), ' ');
};